module.exports = __webpack_public_path__ + "static/src/content/images/processed/200/Chappaquiddick.23098f8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/200/Chappaquiddick.jpg
// module id = hTk5
// module chunks = 0